import React, { useState } from "react";

export default function LiteYouTubeEmbed({ videoId, title = "Vidéo YouTube", aspectRatio = "16/9" }) {
  const [showPlayer, setShowPlayer] = useState(false);
  const thumbnail = `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`;
  return showPlayer ? (
    <iframe
      width="100%"
      height="555"
      src={`https://www.youtube.com/embed/${videoId}?autoplay=1`}
      title={title}
      frameBorder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
      allowFullScreen
      style={{ borderRadius: "10px", display: "block", width: "100%", aspectRatio }}
      loading="lazy"
      fetchpriority="low"
    />
  ) : (
    <div
      className="youtube-lite"
      role="button"
      aria-label={`Lire la vidéo : ${title}`}
      tabIndex={0}
      style={{
        cursor: "pointer",
        position: "relative",
        maxWidth: 1000,
        margin: "30px auto",
        borderRadius: "10px",
        overflow: "hidden",
        aspectRatio: aspectRatio,
        background: "#000"
      }}
      onClick={() => setShowPlayer(true)}
      onKeyDown={e => (e.key === "Enter" || e.key === " ") && setShowPlayer(true)}
    >
      <img
        src={thumbnail}
        alt={`Miniature ${title}`}
        width="100%"
        height="555"
        style={{ display: "block", width: "100%", objectFit: "cover", aspectRatio }}
        loading="lazy"
      />
      {/* Bouton Play SVG blanc centré */}
      <span
        style={{
          position: "absolute",
          left: "50%",
          top: "50%",
          transform: "translate(-50%,-50%)",
          pointerEvents: "none",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
        aria-hidden="true"
      >
        <svg width="68" height="48" viewBox="0 0 68 48">
          <path d="M66.52 7.14c-0.78-2.93-3.07-5.2-6-5.98C56.36 0.21 34 0.21 34 0.21s-22.36 0-26.52 0.96c-2.93 0.78-5.22 3.05-6 5.98C0.5 11.36 0.5 24 0.5 24s0 12.64 0.98 16.86c0.78 2.93 3.07 5.2 6 5.98C11.64 47.79 34 47.79 34 47.79s22.36 0 26.52-0.96c2.93-0.78 5.22-3.05 6-5.98C67.5 36.64 67.5 24 67.5 24s0-12.64-0.98-16.86z" fill="#212121" fillOpacity="0.8" />
          <path d="M45.5 24L27.5 14v20z" fill="#fff" />
        </svg>
      </span>
    </div>
  );
}


// WEBPACK FOOTER //
// ./src/components/LiteYouTubeEmbed.js